'use client';

import { useState, useEffect } from 'react';

import { isSSR } from '@zoomit/primitives';

export const useMenu = () => {
  const [isTransparent, setIsTransparent] = useState(true);

  useEffect(() => {
    if (isSSR) {
      return;
    }

    const handleScroll = () => {
      if (window.scrollY < 100) {
        setIsTransparent(true);
      } else {
        setIsTransparent(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true, capture: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return {
    isTransparent,
  };
};
